export default [
  {
    id: 1,
    title: '100 Years of Solitude',
    author: 'Gabriel Garcia Marquez',
    place: 'Bogata',
    image: 'https://upload.wikimedia.org/wikipedia/en/a/a0/Cien_a%C3%B1os_de_soledad_%28book_cover%2C_1967%29.jpg',
  },
  {
    id: 2,
    title: 'The Pearl',
    author: 'John Steinbeck',
    place: 'La Paz, Mexico',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/The_Pearl_%281947_1st_ed_dust_jacket%29.jpg/440px-The_Pearl_%281947_1st_ed_dust_jacket%29.jpg',
  },
  {
    id: 3,
    title: 'Into the Wild',
    author: 'Jon Krakauer',
    place: 'Denali Borough, Alaska',
    image: 'https://upload.wikimedia.org/wikipedia/en/6/63/Into_the_Wild_%28book%29_cover.png',
  },
  {
    id: 4,
    title: 'Anne of Green Gables',
    author: 'Lucy Maud Montgomery',
    place: 'Prince Edward Island',
    image: 'https://upload.wikimedia.org/wikipedia/commons/8/8b/Montgomery_Anne_of_Green_Gables.jpg',
  },
  {
    id: 5,
    title: 'The Great Gatsby',
    author: 'F Scott Fitzgerald',
    place: 'Hamptons, NY',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/The_Great_Gatsby_Cover_1925_Retouched.jpg/440px-The_Great_Gatsby_Cover_1925_Retouched.jpg',
  },
  {
    id: 6,
    title: 'A River Runs Through It',
    author: 'Norman Maclean',
    place: 'Missoula, Montana',
    image: 'https://upload.wikimedia.org/wikipedia/en/f/f2/NormanMacLean_ARiverRunsThroughIt.jpg',
  },
  {
    id: 7,
    title: 'The Lost World',
    author: 'Sir Arthur Conan Doyle',
    place: 'Manaus, Brazil',
    image: 'https://upload.wikimedia.org/wikipedia/commons/b/b5/Lost_world.jpg',
  },
  {
    id: 8,
    title: 'Keepers of the House',
    author: 'Lisa St Aubin',
    place: 'Caracas, Venezuela',
    image: 'https://upload.wikimedia.org/wikipedia/en/5/5b/KeepersOfTheHouseTeran.JPG',
  },
  {
    id: 9,
    title: 'The Killing Ship',
    author: 'Simon Beaufort',
    place: 'McMurdo Base',
    image: 'https://cdn.waterstones.com/bookjackets/large/9781/8475/9781847517173.jpg',
  },
  {
    id: 10,
    title: 'Endurance: Shackleton\'s Incredible Voyage',
    author: 'Alfred Lansing',
    place: 'McMurdo Base',
    image: 'https://upload.wikimedia.org/wikipedia/en/d/d5/EnduranceShackletonsIncredibleVoyage.jpg',
  },
  {
    id: 11,
    title: 'In Patagonia',
    author: 'Bruce Chatwin',
    place: 'Los Lagos, Chile',
    image: 'https://upload.wikimedia.org/wikipedia/en/6/6a/InPatagonia.jpg',
  },
  {
    id: 12,
    title: 'Little Black Lies',
    author: 'Sharon Bolton',
    place: 'Falkland Islands',
    image: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1428639257l/23014593.jpg',
  },
  {
    id: 13,
    title: 'The Covenant',
    author: 'James Michener',
    place: 'Johannesburg',
    image: 'https://upload.wikimedia.org/wikipedia/en/8/8a/TheCovenant.jpg',
  },
  {
    id: 14,
    title: 'My Sister the Serial Killer',
    author: 'Oyinkan Braithwaite',
    place: 'Lagos, Lagoon',
    image: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1523366732l/38819868._SY475_.jpg',
  },
  {
    id: 15,
    title: 'Waiting',
    author: 'Goretti Kyomuhendo',
    place: 'Lake Albert, DRC',
    image: 'https://images-na.ssl-images-amazon.com/images/I/A1KLY4Z2uqL.jpg',
  },
  {
    id: 16,
    title: 'A General Theory of Oblivion',
    author: 'Jose Eduardo Agualusa',
    place: 'Luanda, Angola',
    image: 'https://upload.wikimedia.org/wikipedia/en/thumb/b/b9/A_General_Theory_of_Oblivion.jpg/220px-A_General_Theory_of_Oblivion.jpg',
  },
  {
    id: 17,
    title: 'Death on the Nile',
    author: 'Agatha Christie',
    place: 'Cairo, Egypt',
    image: 'https://upload.wikimedia.org/wikipedia/en/9/96/Death_on_the_Nile_First_Edition_Cover_1937.jpg',
  },
  {
    id: 18,
    title: 'The Talented Mr Ripley',
    author: 'Patricia Highsmith',
    place: 'Naples, Italy',
    image: 'https://m.media-amazon.com/images/I/51zazdnfdpL.jpg',
  },
  {
    id: 19,
    title: 'Pride And Prejudice',
    author: 'Jane Austen',
    place: 'Hertfordshire, England',
    image: 'https://images-na.ssl-images-amazon.com/images/I/91HqOO4DmRL.jpg',
  },
  {
    id: 20,
    title: 'The Girl With The Dragon Tattoo',
    author: 'Stieg Larsson',
    place: 'Stockholm, Sweden',
    image: 'https://images.penguinrandomhouse.com/cover/9780307454546',
  },
  {
    id: 21,
    title: 'A Moveable Feast',
    author: 'Ernest Hemingway',
    place: 'Paris, France',
    image: 'https://upload.wikimedia.org/wikipedia/en/a/aa/MoveableFeast.jpg',
  },
  {
    id: 22,
    title: 'The Girl With The Pearl Earring',
    author: 'Tracey Chevalier',
    place: 'Oude Kerk',
    image: 'https://cdn.waterstones.com/bookjackets/large/9780/0072/9780007232161.jpg',
  },
  {
    id: 23,
    title: 'Maya',
    author: 'Jostein Gaarder',
    place: 'Taveuni, Fiji',
    image: 'https://images-na.ssl-images-amazon.com/images/I/51atGyM+2NL._SX321_BO1,204,203,200_.jpg',
  },
  {
    id: 24,
    title: 'The Whale Rider',
    author: 'Witi Ihimaera',
    place: 'Whangara, East Coast New Zealand',
    image: 'https://upload.wikimedia.org/wikipedia/en/2/2b/Whale_Rider_movie_poster.jpg',
  },
  {
    id: 25,
    title: 'The Secret River',
    author: 'Kate Grenville',
    place: 'Hawkesbury River, Australia',
    image: 'https://d2wzqffx6hjwip.cloudfront.net/spree/images/attachments/000/045/519/product/9781922147424.jpg?1594753393',
  },
  {
    id: 26,
    title: 'The Kite Runner',
    author: 'Khaled Hosseini',
    place: 'Kabul, Afghanistan',
    image: 'https://cdn.waterstones.com/bookjackets/large/9781/5266/9781526604743.jpg',
  },
  {
    id: 27,
    title: 'The Last Children of Tokyo',
    author: 'Yoko Tawada',
    place: 'Tokyo, Japan',
    image: 'https://images-na.ssl-images-amazon.com/images/I/41rHGRvQcWL._SX312_BO1,204,203,200_.jpg',
  },
  {
    id: 28,
    title: 'Shanghai Girls',
    author: 'Lisa See',
    place: 'Shanghai, China',
    image: 'https://images-na.ssl-images-amazon.com/images/I/51UwYw5pNSL.jpg',
  }
]
